import { render } from "./GetStartedPage.vue?vue&type=template&id=7d4a93de&scoped=true"
import script from "./GetStartedPage.vue?vue&type=script&lang=js"
export * from "./GetStartedPage.vue?vue&type=script&lang=js"

import "./GetStartedPage.vue?vue&type=style&index=0&id=7d4a93de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4a93de"]])

export default __exports__